import { useId, cloneElement, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

export const Input = forwardRef(
  (
    {
      render,
      label,
      id,
      icon: initialIcon,
      iconAfter,
      containerClassName,
      inputClassName,
      labelClassName,
      altLabel,
      altLabelClassName,
      className,
      disabled,
      shadow = true,
      error,
      errorClassName,
      instruction,
      instructionClassName,
      ...props
    },
    ref
  ) => {
    const genId = useId();
    const icon = initialIcon
      ? cloneElement(initialIcon, {
          className: twMerge('shrink-0', initialIcon.props?.className)
        })
      : null;
    const isSmall = inputClassName?.includes?.('input-sm');
    return (
      <fieldset className={twMerge('fieldset w-full', containerClassName)}>
        {!!(label || altLabel) && (
          <legend className="contents">
            <div
              className={twMerge(
                'flex items-baseline',
                altLabel && 'justify-between w-full'
              )}
            >
              {!!label && (
                <label
                  className={twMerge('fieldset-legend pb-1', labelClassName)}
                  htmlFor={id || genId}
                >
                  {label}
                </label>
              )}
              {!!altLabel && (
                <span className={twMerge('fieldset-label', altLabelClassName)}>
                  {altLabel}
                </span>
              )}
            </div>
          </legend>
        )}
        <div
          className={twMerge(
            'input input-beautifi rounded-full relative flex items-center px-0 overflow-hidden',
            !disabled && 'shadow-beautifi',
            disabled && 'input-disabled opacity-40',
            error ? 'input-error text-error' : '',
            inputClassName
          )}
        >
          {!render && (
            <input
              {...props}
              id={id || genId}
              ref={ref}
              className={twMerge(
                'grow h-full px-4',
                !!icon && (isSmall ? 'ps-7' : 'ps-12'),
                !!iconAfter && (isSmall ? 'pe-7' : 'pe-12'),
                className
              )}
              disabled={disabled}
            />
          )}
          {!!render &&
            render({
              className: twMerge(
                'grow min-h-full px-4',
                !!icon && 'ps-12',
                className
              ),
              id: id || genId,
              disabled,
              ...props
            })}
          {!!icon && (
            <div className={twMerge('absolute', isSmall ? 'ps-2' : 'ps-4')}>
              {icon}
            </div>
          )}
          {!!iconAfter && (
            <div
              className={twMerge(
                'absolute inset-e-0',
                isSmall ? 'pe-2' : 'pe-4'
              )}
            >
              {iconAfter}
            </div>
          )}
        </div>
        {!!error?.message && (
          <p className={twMerge('fieldset-label text-error', errorClassName)}>
            {error?.message}
          </p>
        )}
        {!!instruction && (
          <div className={twMerge('fieldset-label', instructionClassName)}>
            {typeof instruction === 'string' ? (
              <span className="opacity-60">{instruction}</span>
            ) : (
              instruction
            )}
          </div>
        )}
      </fieldset>
    );
  }
);

Input.displayName = 'Input';
